import { RootState } from '~/store';

export const subscribeBookModalSelector = (state: RootState) => state.subscribeBookModal;
